import React from 'react'
import { Link } from 'react-router-dom';
import Button from '../button/Button';
import "./categoryCard.scss";
import PropTypes from "prop-types";

const CategoryCard = props => {
    return (
        <Link to={`/categories/${props.title}`}>
            <div className="category-card" style={{ backgroundImage: `url(${props.image})` }}>
                <Button>View</Button>
            </div>
            <h3>{props.title}</h3>
        </Link>
    )
}

CategoryCard.propTypes = {
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}

export default CategoryCard